import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'
import getAll from 'utils/getAll'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setServiceStatuses: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    const serviceStatusesRequest = getAll(apiUrls.serviceStatuses).then((data) => {
      props.setServiceStatuses(data)
    })

    if (props.id !== undefined) {
      const recordRequest = loadRecord(apiUrls.serviceStatuses, props.id, [
        'zeroDaysSinceServiceStatus',
        'hundredPlusDaysSinceServiceStatus',
      ])

      Promise.all([serviceStatusesRequest, recordRequest]).then(([, data]) => {
        props.reset(data)
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      serviceStatusesRequest.then(() => {
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    }
  }, [])
}

export default useInit
